export const sharingClickAction = () => {
  let isSharing = false;
  const sharingIcon = window.storeeelItems.isMobile
    ? document.querySelector('.storeeel-menu-area-icons img[alt="sharing"]')
    : document.querySelector('#sharing-desktop');

  sharingIcon.addEventListener('click', async () => {
    if (isSharing) return;

    try {
      isSharing = true;

      const container = document.querySelector('.storeeelSwiper .swiper-slide-active .slide-media-wrapper');
      if (!container) return;

      // video/img を全部拾って「表示中のもの」を選ぶ
      const candidates = Array.from(container.querySelectorAll('video, img'));
      const visible = candidates.find(el => {
        const cs = window.getComputedStyle(el);
        return cs.display !== 'none' && cs.visibility !== 'hidden' && el.offsetParent !== null;
      });

      const target = visible || candidates[candidates.length - 1]; // 念のためフォールバック
      if (!target) return;

      await window.navigator.share({ url: target.src });
    } catch {
      // noop
    } finally {
      isSharing = false;
    }
  });
};